// Normalised error surfaced by BaseApiClient so UI/hooks handle one shape.
export class ApiError extends Error {
  constructor({ message, status, code, fieldErrors, raw }) {
    super(message || 'Something went wrong');
    this.name = 'ApiError';
    this.status = status ?? 0;
    this.code = code ?? null;
    this.fieldErrors = fieldErrors ?? null; // { field: 'message' }
    this.raw = raw ?? null;
  }
}

// Extract field-level validation errors from common ASP.NET / envelope shapes.
export const extractFieldErrors = (data) => {
  if (!data) return null;
  // ASP.NET ModelState: { errors: { Field: ["msg"] } }
  if (data.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
    const out = {};
    for (const [key, val] of Object.entries(data.errors)) {
      const f = key.charAt(0).toLowerCase() + key.slice(1);
      out[f] = Array.isArray(val) ? val[0] : String(val);
    }
    return Object.keys(out).length ? out : null;
  }
  return null;
};
